import React from 'react'
import {useIntl} from 'react-intl'
import {CSSTransition} from 'react-transition-group'

interface EmailDetailViewProps {
  displayEmail: string
  onBack: () => void
}

export const EmailDetailView: React.FC<EmailDetailViewProps> = ({displayEmail, onBack}) => {
  const intl = useIntl()

  return (
    <CSSTransition appear in timeout={300} classNames='fade' unmountOnExit>
      <div className='mb-4'>
        <div className='d-flex flex-column align-items-center justify-content-center'>
          <div className='d-flex justify-content-start w-100 settings-header'>
            <h1 className='d-flex flex-column text-dark fw-boldest my-0 fs-1'>
              {intl.formatMessage({id: 'SECURITY'})}
            </h1>
          </div>
          <div className='card settings-card w-100 border border-secondary rounded-3 py-6 px-8 mt-6'>
            {/* Title with Back Arrow */}
            <div className='d-flex align-items-center mb-3'>
              <i
                className='bi bi-chevron-left fs-4 text-gray-600 me-2 cursor-pointer'
                onClick={onBack}
              ></i>
              <h4 className='fw-bold mb-0 ms-2'>
                {intl.formatMessage({id: 'TWO_FACTOR_AUTHENTICATION_EMAIL'})}
              </h4>
            </div>

            {/* Description */}
            <div className='ms-xxl-5'>
              <p className='text-gray-800 mb-5 ms-xxl-5'>
                {intl.formatMessage({id: 'EMAIL_2FA_DESCRIPTION'})}
              </p>
              <br />

              {/* Email Display */}
              <div className='text-gray-900 ms-xxl-5 fs-6'>{displayEmail}</div>
            </div>
          </div>
        </div>
      </div>
    </CSSTransition>
  )
}
